import React, { memo } from 'react';
import { InventoryCountStatus as status } from 'types/inventory';
import { InventoryCountTabProps } from './InventoryCount.props';
import { InventoryTabContent } from './InventoryTabContent';

export const DoneInventory = memo<InventoryCountTabProps>((props) => {
  return (
    <InventoryTabContent status={status.DONE} {...props}></InventoryTabContent>
  );
});
